<template>
  <!-- TODO temporary search instance for showing the related products. -->
  <AisInstantSearch
    :search-client="searchStore.getAlgoliaClient()"
    :index-name="`${productStore.productIndex}_popular_desc`"
  >
    <AisConfigure :hits-per-page.camel="5" />

    <h3 class="mb-3 text-xl font-bold">
      {{ $t('pages.product_detail_page.related_products.title') }}
    </h3>

    <div ref="products" class="w-full overflow-x-auto">
      <AisHits class="relative flex w-full flex-nowrap transition-all">
        <template #default="{ items }">
          <RelatedEntry
            v-for="item of items"
            :key="item.objectID"
            :item="item"
          />
        </template>
      </AisHits>
    </div>

    <div
      v-if="hasHorizontalScroll"
      class="flex flex-1 items-center justify-center p-4"
    >
      <button
        :aria-label="$t('pages.product_detail_page.related_products.previous')"
        :class="{ 'opacity-50': arrivedState.left }"
        class="mx-4 h-8 w-8 rounded-full text-black outline-none focus:outline-none"
        @click="x -= scrollStepSize"
      >
        <ChevronLeftIcon />
      </button>

      <button
        :aria-label="$t('pages.product_detail_page.related_products.next')"
        :class="{ 'opacity-50': arrivedState.right }"
        class="mx-4 h-8 w-8 rounded-full text-black outline-none focus:outline-none"
        @click="x += scrollStepSize"
      >
        <ChevronRightIcon />
      </button>
    </div>
  </AisInstantSearch>
</template>

<script setup lang="ts">
import RelatedEntry from '@/pages/ProductPage/partials/RelatedEntry.vue';
import { useAlgoliaProductStore } from '@/stores/Category/AlgoliaProductStore';
import { useAlgoliaSearchStore } from '@/stores/Category/AlgoliaSearchStore';
import { computed, useTemplateRef } from 'vue';
import { useElementSize, useScroll, useWindowSize } from '@vueuse/core';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/20/solid';

const productStore = useAlgoliaProductStore();
const searchStore = useAlgoliaSearchStore();

const productsElement = useTemplateRef<HTMLElement>('products');
const { x, arrivedState } = useScroll(productsElement, { behavior: 'smooth' });
const { width: windowWidth } = useWindowSize();
const { width: elementWidth } = useElementSize(productsElement);
const scrollStepSize = computed(() => windowWidth.value / 2);
const hasHorizontalScroll = computed(() => {
  if (!productsElement.value) {
    return false;
  }
  return productsElement.value.scrollWidth > elementWidth.value;
});
</script>
